import { useState } from "react";
import { LocalizedLink as Link } from "./LocalizedLink";
import { ArrowRight } from "lucide-react";

type FlipCardProps = {
  className?: string;
  frontContent: React.ReactNode;
  backContent: React.ReactNode;
  bgCard?: string;
  bgButton?: string;
  detailHref?: string;
  detailLabel?: string;
  detailAriaLabel?: string;
};

export default function FlipCard({
  className = "w-full aspect-[3/4]",
  frontContent,
  backContent,
  bgCard,
  bgButton,
  detailHref,
  detailLabel = "Ver detalles",
  detailAriaLabel,
}: FlipCardProps) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className={`flip-card relative [perspective:1000px] ${flipped ? "is-flipped" : ""} ${className}`}>
      <div className="flip-card__inner relative w-full h-full">
        {/* Frente */}
        <div
          className={`flip-card__face flip-card__face--front rounded-xl shadow-md ${bgCard} p-4`}
        >
          {frontContent}

          <button
            type="button"
            onClick={() => setFlipped(true)}
            className={`mt-auto text-sm px-3 py-1 rounded-md ${bgButton} text-primary-foreground`}
          >
            Más información
          </button>
        </div>

        {/* Reverso */}
        <div
          className={`flip-card__face flip-card__face--back rounded-xl shadow-md ${bgCard} p-4`}
        >
          {backContent}

          {detailHref && (
            <Link
              to={detailHref}
              className="mt-4 inline-flex items-center justify-center gap-2 rounded-md border border-primary/20 bg-white/70 px-3 py-2 text-sm font-semibold text-foreground transition-colors hover:bg-white"
              aria-label={detailAriaLabel || detailLabel}
            >
              {detailLabel}
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          )}

          <button
            type="button"
            onClick={() => setFlipped(false)}
            className={`mt-auto text-sm px-3 py-1 rounded-md ${bgButton} text-primary-foreground`}
          >
            Regresar
          </button>
        </div>
      </div>
    </div>
  );
}
